import './src/styles/global.css'

// /context paints from its own stylesheet, which a client-side route change would only add after the page has
// rendered. Links to it skip the router and load the page, so it shows styled from the first frame.
const FULL_LOAD = /^\/(fr\/)?context\/?$/

export const onClientEntry = () => {
    document.addEventListener("click", e => {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
        const a = e.target.closest && e.target.closest("a[href]")
        if (!a || a.target && a.target !== "_self" || a.origin !== window.location.origin) return
        // Google Analytics' cross-domain linker adds _gl to the link it sees navigate, which would leave it in the address
        // bar. It is our own domain, so the load goes to the link without it.
        if (FULL_LOAD.test(a.pathname) && a.pathname !== window.location.pathname) {
            e.preventDefault()
            e.stopPropagation()
            const url = new URL(a.href)
            url.searchParams.delete("_gl")
            window.location.assign(url.href)
            return
        }
        // The same goes for its in-page links (Book a demo): the router would count the new hash as a route change and
        // put the stylesheet back in the head, which drops the page's styles until it has loaded again. They scroll here
        // instead, and the URL takes the hash without a route change.
        const target = a.hash && a.pathname === window.location.pathname && a.closest("#ctx-embed")
            && document.getElementById(decodeURIComponent(a.hash.slice(1)))
        if (!target) return
        e.preventDefault()
        e.stopPropagation()
        window.history.replaceState(window.history.state, "", a.hash)
        target.scrollIntoView()
        target.focus({preventScroll: true})
    }, true)
}
